import { CheckCircleIcon } from '@heroicons/react/24/outline'

export function ExtensionCallbackPage() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="border border-app-line bg-app-surface/50 p-8 text-center max-w-md rounded-2xl shadow-app-card">
        <CheckCircleIcon className="mx-auto h-12 w-12 text-emerald-700 dark:text-emerald-400" />
        <h2 className="mt-4 text-lg font-semibold text-app-ink font-display">Extension Connected</h2>
        <p className="mt-2 text-sm text-app-muted">
          Your browser extension is now connected to your JobTrackr account.
          You can close this tab.
        </p>
      </div>
    </div>
  )
}
